import React from 'react';
import { Link } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useLanguage } from '../../contexts/LanguageContext';
import { t } from '../../translations/translations';
import { SPECIAL_SERVICES } from '../../data/mock';

export const ComplexProjectsSection = () => {
  const { language } = useLanguage();

  return (
    <section className="py-20 bg-[#fefdf4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-medium text-gray-900 mb-4">
            {t(language, 'sections.buildingComplex')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t(language, 'sections.buildingComplexDesc')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {SPECIAL_SERVICES.map((service) => {
            const Icon = LucideIcons[service.icon];
            return (
              <div key={service.key} className="bg-gray-50 p-6 rounded-lg border border-gray-200 hover:bg-blue-50 hover:border-blue-900 transition-all duration-300">
                <Icon className="w-10 h-10 text-blue-900 mb-4" />
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{t(language, `specialServices.${service.key}`)}</h3>
                <p className="text-gray-600">{t(language, `specialServices.${service.key}Desc`)}</p>
              </div>
            );
          })}
        </div>

        {/* Fit callout */}
        <div className="mt-14 max-w-3xl mx-auto" data-testid="home-fit-callout">
          <div className="border border-gray-200 rounded-lg bg-white px-8 py-8 md:px-10 md:py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div className="md:pr-8">
              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-2">
                {t(language, 'sections.notSureRoute')}
              </h3>
              <p className="text-base text-gray-600 leading-relaxed">
                {t(language, 'sections.notSureRouteDesc')}
              </p>
            </div>
            <div className="flex-shrink-0">
              <Link to="/fit">
                <Button
                  data-testid="home-find-your-fit-btn"
                  variant="outline"
                  className="border-blue-900 text-blue-900 hover:bg-blue-900 hover:text-white px-6"
                >
                  {t(language, 'sections.findYourFit')}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
